/**
 * Farbtöne der Oberfläche (eine Stelle).
 * Hintergrund der Statusflächen bleibt hell, die stärkere Farbe sitzt im Text.
 */
export const palette = {
  primary: '#334155',
  primarySoft: '#EEF2F6',
  success: '#287A61',
  successSoft: '#ECF7F2',
  warning: '#A66416',
  warningSoft: '#FFF6E8',
  danger: '#A94442',
  dangerSoft: '#FCEEEE',
  neutral: '#475569',
  neutralSoft: '#F5F7F9',
  border: '#DDE3EA',
  text: '#1E293B',
  canvas: '#F5F7F9',
};

export const CHIP_CLASS = {
  neutral: 'bg-[#F5F7F9] text-[#475569] border-[#DDE3EA]',
  primary: 'bg-[#EEF2F6] text-[#334155] border-[#DDE3EA]',
  success: 'bg-[#ECF7F2] text-[#287A61] border-[#DDE3EA]',
  warning: 'bg-[#FFF6E8] text-[#A66416] border-[#DDE3EA]',
  danger: 'bg-[#FCEEEE] text-[#A94442] border-[#DDE3EA]',
};

export function chipStyle(tone) {
  const map = {
    neutral: [palette.neutralSoft, palette.neutral],
    primary: [palette.primarySoft, palette.primary],
    success: [palette.successSoft, palette.success],
    warning: [palette.warningSoft, palette.warning],
    danger: [palette.dangerSoft, palette.danger],
  };
  const [bg, fg] = map[tone] || map.neutral;
  return { background: bg, color: fg, borderColor: palette.border };
}
